import Navigation from '../../Components/Navigation';

const ConfirmedWaiting = () => {
    const linkBack = ""
    const linkSkip = ""

  return (
    <div className="min-h-screen bg-black flex flex-col">
      <main className="flex-1 flex items-center justify-center px-6 py-8">
        <div className="w-full max-w-[420px] text-center">
          {/* Upper section */}
          {/* <div className='flex flex-1 justify-between flex-col'>
            <div className='mt-3'>
              <h2 className='text-xl text-center text-[#fff]'>
                houtive
              </h2>
            </div>
            <Navigation
              linkBack={linkBack}
              linkSkip={linkSkip}
              showLinkBack={false} 
              showLinkSkip={false}
            />
          </div> */}
          {/* Middle section */}
          <div className="flex flex-1 justify-center flex-col w-full max-w-[420px] px-6">
            <h2 className="text-2xl sm:text-3xl font-semibold text-center leading-tight text-white mb-2">
              Du står nu på väntelistan 🎉
            </h2>
            <p className="text-center text-sm sm:text-base text-[#D6D6D6] leading-relaxed mb-4">
              Vi smsar dig så fort en plats blir tillgänglig.
            </p>
            <p className="text-center text-sm sm:text-base text-[#D6D6D6] leading-relaxed mb-4">
              Vill du lära dig mer om Houtive under tiden, besök <a className='underline' href="https://www.houtive.com">houtive.com</a>. Tack! 🙏
            </p>
          </div>
        </div>
      </main>
      
  </div>
  );
}

export default ConfirmedWaiting;
